































































import Vue from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";

import HolidayProgramJson from "../../shared/HolidayProgramJson";
import HolidayProgramBookingJson from "../../shared/HolidayProgramBookingJson";

export default Vue.extend({
  name: "HolidaysParticipantsPrintListByGroup",
  components: {
    Loading,
  },
  props: {
    holidayProgramInfo: Object,
    holidayProgramBookingsByGroup: Object,
    holidayProgramBookings: Array,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
    };
  },
  created() {},
  methods: {
    getAllHolidayProgramDates(holidayProgram: HolidayProgramJson) {
      var dates = [];

      var current = new Date(holidayProgram.beginDate);

      while (current <= new Date(holidayProgram.endDate)) {
        dates.push(DateFormatter.formatISODate(current));
        current.setDate(current.getDate() + 1);
      }

      return dates;
    },
  },
  watch: {},
  computed: {},
});
